// Transaction sagas — generated from the family table.
//
// Twelve watchers (four operations across three families) from one loop, rather
// than twelve hand-written copies of the same try/catch.
//
// All of them use the takeLatest equivalent: these are read-only list, detail
// and statistics fetches, and a filter change must never be overtaken by its
// own stale response.

import * as types from '../../lib/actionTypes.es6';
import { FAMILIES } from './families.es6';
import allActions, {
  getCalculationLogSuccess,
  getCalculationLogFailed
} from './actions.es6';
import { makeLatestWatcher } from '../../components/CommissionsShared/makeWatcher.es6';
import {
  getCommissionTransactions,
  getCommissionTransactionByGuid,
  getCommissionTransactionsByAgent,
  getCommissionTransactionStats,
  getClawbackTransactions,
  getClawbackTransactionByGuid,
  getClawbackTransactionsByAgent,
  getClawbackTransactionStats,
  getPayoutTransactions,
  getPayoutTransactionByGuid,
  getPayoutTransactionsByAgent,
  getPayoutTransactionStats,
  getCommissionCalculationLog
} from '../../lib/requests.es6';

// The endpoint functions live here rather than in families.es6.js: that module
// is imported by the reducer and the components, and pulling requests.es6 into
// it closes an import cycle through store/rootSaga that leaves FAMILIES
// undefined depending on module init order.
var API = {
  commission: {
    list: getCommissionTransactions,
    detail: getCommissionTransactionByGuid,
    byAgent: getCommissionTransactionsByAgent,
    stats: getCommissionTransactionStats
  },
  clawback: {
    list: getClawbackTransactions,
    detail: getClawbackTransactionByGuid,
    byAgent: getClawbackTransactionsByAgent,
    stats: getClawbackTransactionStats
  },
  payout: {
    list: getPayoutTransactions,
    detail: getPayoutTransactionByGuid,
    byAgent: getPayoutTransactionsByAgent,
    stats: getPayoutTransactionStats
  }
};

// Accepts { agentGuid, ...params } or a bare guid.
function agentArgs(payload) {
  var request = payload || {};
  if (typeof request === 'string') return [request, {}];
  var params = Object.assign({}, request);
  delete params.agentGuid;
  return [request.agentGuid, params];
}

function guidArgs(payload) {
  return [payload && payload.guid ? payload.guid : payload];
}

var watchers = {};

FAMILIES.forEach(function(family) {
  var actions = allActions[family.key];
  var api = API[family.key];

  watchers[family.key] = {
    list: makeLatestWatcher(
      family.types.list.request,
      api.list,
      actions.listSuccess,
      actions.listFailed
    ),
    detail: makeLatestWatcher(
      family.types.detail.request,
      api.detail,
      actions.detailSuccess,
      actions.detailFailed,
      { args: guidArgs }
    ),
    byAgent: makeLatestWatcher(
      family.types.byAgent.request,
      api.byAgent,
      actions.byAgentSuccess,
      actions.byAgentFailed,
      { args: agentArgs }
    ),
    stats: makeLatestWatcher(
      family.types.stats.request,
      api.stats,
      actions.statsSuccess,
      actions.statsFailed
    )
  };
});

export var getCommissionCalculationLogRequestWatcher = makeLatestWatcher(
  types.GET_COMMISSION_CALCULATION_LOG_REQUEST,
  getCommissionCalculationLog,
  getCalculationLogSuccess,
  getCalculationLogFailed
);

// Every watcher, for the root saga to start in one go.
export function transactionWatchers() {
  var all = [];
  Object.keys(watchers).forEach(function(key) {
    var family = watchers[key];
    Object.keys(family).forEach(function(operation) {
      all.push(family[operation]());
    });
  });
  return all;
}

// Named exports kept so the root saga's existing import list keeps working.
export var getCommissionTransactionsRequestWatcher = watchers.commission.list;
export var getCommissionTransactionByGuidRequestWatcher =
  watchers.commission.detail;
export var getCommissionTransactionsByAgentRequestWatcher =
  watchers.commission.byAgent;
export var getCommissionTxnStatsRequestWatcher = watchers.commission.stats;

export var getClawbackTransactionsRequestWatcher = watchers.clawback.list;
export var getClawbackTransactionByGuidRequestWatcher =
  watchers.clawback.detail;
export var getClawbackTransactionsByAgentRequestWatcher =
  watchers.clawback.byAgent;
export var getClawbackTxnStatsRequestWatcher = watchers.clawback.stats;

export var getPayoutTransactionsRequestWatcher = watchers.payout.list;
export var getPayoutTransactionByGuidRequestWatcher = watchers.payout.detail;
export var getPayoutTransactionsByAgentRequestWatcher = watchers.payout.byAgent;
export var getPayoutTxnStatsRequestWatcher = watchers.payout.stats;
